export default "__VITE_ASSET__BQgSQRjH__"